import { toURLSearchParams } from '@wix/sdk-runtime/rest-modules';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveWixFunctionsFormschemasV1FunctionFormSchemasUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'dev._base_domain_': [
      {
        srcPath: '/_api/functions/v1/function-form-schemas',
        destPath: '/v1/function-form-schemas',
      },
    ],
    'manage._base_domain_': [
      {
        srcPath: '/_api/functions/v1/function-form-schemas',
        destPath: '/v1/function-form-schemas',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/functions/v1/function-form-schemas',
        destPath: '/v1/function-form-schemas',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_functions_function-form-schemas';

/** Retrieves a FunctionFormSchema. */
export function getFunctionFormSchema(
  payload: object
): RequestOptionsFactory<any> {
  function __getFunctionFormSchema({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.functions.v1.function_form_schema',
      method: 'GET' as any,
      methodFqn:
        'wix.functions.formschemas.v1.FunctionFormSchemas.GetFunctionFormSchema',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixFunctionsFormschemasV1FunctionFormSchemasUrl({
        protoPath: '/v1/function-form-schemas/{functionId}',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
    };

    return metadata;
  }

  return __getFunctionFormSchema;
}
